import { EOrderExpiry, EOrderIndicate } from '@webtrader/core/api/order';
import request from '@webtrader/core/request';

export enum ETradeFillPolicy {
  FOK,
  IOC,
  RETURN,
  GTC
}

export enum ETradeFillPolicyValue {
  FOK = 'FOK',
  IOC = 'IOC',
  RETURN = 'RETURN',
  GTC = 'GTC',
  GTD = 'GTD',
  DAY = 'DAY'
}

export enum ECloseMarketOrderType {
  FULL_CLOSE = 'Full Close',
  PARTIAL_CLOSE = 'Partial Close'
}

export interface ICloseMarketTradeParams {
  orderId: string;
  symbol: string;
  lotSize: number;
  fillPolicy?: ETradeFillPolicy;
}

export interface IUpdateLimitParams {
  price: number;
  symbol: string;
  orderId: number;
  indicate: EOrderIndicate;
  tradeExpiry: EOrderExpiry;
  stopLoss?: number;
  takeProfit?: number;
}

export interface IUpdateMarketParams {
  symbol: string;
  orderId: number;
  indicate: EOrderIndicate;
  stopLoss?: number;
  takeProfit?: number;
}

export interface IClosePendingLimitTradeParams {
  orderId: string;
  symbol?: string;
}

export interface IBulkCloseMarketRequest {
  orderList: ICloseMarketTradeParams[];
}

export interface IBulkCloseMarketResponse {
  closedOrderIds: number[];
}

export interface IBulkDeletePendingRequest {
  orderId: string;
  symbol: string;
}

export interface IBulkDeletePendingResponse {
  deletedOrderIds: number[];
}

export default {
  closeMarket: (params: ICloseMarketTradeParams) => request.put<boolean>('/api/trade/v2', params),
  closePendingLimit: (params: IClosePendingLimitTradeParams) =>
    request.delete<boolean>('/api/trade/v2', {
      params
    }),
  bulkCloseMarket: (params: IBulkCloseMarketRequest) =>
    request.put<IBulkCloseMarketResponse>('/api/trade/v1/bulk', params),
  bulkDeletePending: (params: IBulkDeletePendingRequest[]) =>
    request.put<IBulkDeletePendingResponse>('/api/trade/v1/limit/bulk', params)
};
